<!-- Иконка сброса выбранного периода календаря. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18 6L6 18M6 6L18 18" :stroke="stroke" stroke-width="2.5" />
  </svg>
</template>

<script>
export default {
  name: "CalendarRangeClearIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
